export type LogMessage = {
  message: string;
  correlationId?: string;
  object?: object;
  includeTrace?: boolean;
};

export enum LogLevel {
  NONE = 'none',
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error'
}

export const LogLevelPriority: Record<LogLevel, number> = {
  [LogLevel.NONE]: 0,
  [LogLevel.INFO]: 1,
  [LogLevel.WARN]: 2,
  [LogLevel.ERROR]: 3,
  [LogLevel.DEBUG]: 4
} as const;
